<div class="md-form" *ngIf="vm">
    <div *ngIf="!showSimple">
        <ng-template #popTemplate>
            <div>
                <span>{{vm.helpText}}</span>
            </div>
            <div *ngIf="validationErrors.length">
                <p class="text-danger" *ngFor="let ve of validationErrors">{{ve}}</p>
            </div>
        </ng-template>
        <label *ngIf="vm.display.description" style="cursor: pointer;" class="pb-1" [mdbPopoverHeader]="vm.display.description" [mdbPopover]="popTemplate" triggers="hover">{{vm.display.description}}
            <mdb-icon *ngIf="validationErrors.length" class="text-danger" fas icon="exclamation-circle"></mdb-icon>
            <mdb-icon *ngIf="vm.isLocked" style="color: #e0e0e0;" fas icon="lock"></mdb-icon>
        </label>
        <mdb-select [ngModel]="optionValue" (ngModelChange)="modelChanged(vm, $event)" [disabled]="vm.isLocked"
            #select_ref="ngModel" [required]="isRequired" [options]="vm.display.options" [placeholder]="vm.placeholder" [multiple]="vm.display.multiple">
        </mdb-select>
    </div>

    <div *ngIf="showSimple">
        <mdb-badge primary="true">{{vm.description}}</mdb-badge><br />
        <span>{{vm.optionReadonly}}</span>
    </div>
</div>